import { RootState } from '../../../app';

export const selectLinkedinProfileId = ({ integrations }: RootState) =>
  integrations.linkedinProfileId;

export const selectLinkedinProfileName = ({ integrations }: RootState) =>
  integrations.linkedinProfileName;

export const selectLinkedinProfilePicture = ({ integrations }: RootState) =>
  integrations.linkedinProfilePicture;

export const selectIsSharingLinkedinPost = ({ integrations }: RootState) =>
  integrations.isSharingLinkedinPost;

export const selectIsLoggedIntoLinkedin = ({ integrations }: RootState) =>
  integrations.isLoggedIntoLinkedin;

export const selectIsRevokingLinkedinToken = ({ integrations }: RootState) =>
  integrations.isRevokingLinkedinToken;

export const selectSocialPostContent = ({ integrations }: RootState) =>
  integrations.socialPostContent;

export const selectIsPostCoverLoading = ({ integrations }: RootState) =>
  integrations.isPostCoverLoading;

export const selectIsConnectingToLinkedin = ({ integrations }: RootState) =>
  integrations.isConnectingToLinkedin;

export const selectIsConnectingToTwitter = ({ integrations }: RootState) =>
  integrations.isConnectingToTwitter;

export const selectIsLoggedIntoTwitter = ({ integrations }: RootState) =>
  integrations.isLoggedIntoTwitter;

export const selectIsSharingTwitterPost = ({ integrations }: RootState) =>
  integrations.isSharingTwitterPost;

export const selectIsRevokingTwitterToken = ({ integrations }: RootState) =>
  integrations.isRevokingTwitterToken;

export const selectTwitterProfileName = ({ integrations }: RootState) =>
  integrations.twitterProfileName;

export const selectTwitterProfilePicture = ({ integrations }: RootState) =>
  integrations.twitterProfilePicture;

export const selectIsConnectingToSalesforce = ({ integrations }: RootState) =>
  integrations.isConnectingToSalesforce;

export const selectIsUpdatingSalesforceSettings = ({
  integrations,
}: RootState) => integrations.isUpdatingSalesforceSettings;

export const selectIsZapierLoading = ({ integrations }: RootState) =>
  integrations.isZapierLoading;

export const selectSalesforceObjects = ({ integrations }: RootState) =>
  integrations.salesforceObjects;

export const selectHubspotObjects = ({ integrations }: RootState) =>
  integrations.hubspotObjects;

export const selectIsCRMObjectsLoading = ({ integrations }: RootState) =>
  integrations.isCRMObjectsLoading;

export const selectIsEnterpriseOnlyModalOpen = ({ integrations }: RootState) =>
  integrations.isEnterpriseOnlyModalOpen;

export const selectIsConnectingToHubspot = ({ integrations }: RootState) =>
  integrations.isConnectingToHubspot;

export const selectIsDisconnectingFromHubspot = ({ integrations }: RootState) =>
  integrations.isDisconnectingFromHubspot;

export const selectIsUpdatingHubspotSettings = ({ integrations }: RootState) =>
  integrations.isUpdatingHubspotSettings;
